/**
 * How long after login an unknown organization sound policy counts as "on" for
 * a new Critical incident (ENG-35923).
 *
 * Right after a fresh login the policy has not been read yet, and a Critical
 * incident arriving in that gap would be silent for an operator with audio
 * alerts off or the bell muted, with no way to recover it later. For a safety
 * alert, a possibly unneeded sound in the first seconds beats silence.
 *
 * It is bounded on purpose. If the policy never loads (a failed or hung
 * request, a backend without the field), counting it as "on" forever would
 * make every operator hear Critical incidents whatever their own settings, so
 * the policy falls back to its default (off) once the grace period ends.
 */
export const CRITICAL_SOUND_POLICY_GRACE_MS = 10_000

let syncStartedAt: number | null = null

/** The policy sync became active (a logged-in user). Only the first call counts. */
export const markCriticalSoundPolicySyncStarted = (): void => {
  if (syncStartedAt === null) syncStartedAt = Date.now()
}

/** The sync stopped (logout, or incident audio turned off). */
export const resetCriticalSoundPolicySyncStart = (): void => {
  syncStartedAt = null
}

export const isWithinCriticalSoundPolicyGrace = (): boolean =>
  syncStartedAt !== null &&
  Date.now() - syncStartedAt < CRITICAL_SOUND_POLICY_GRACE_MS
